import { APP_INITIALIZER, Inject, Injectable } from "@angular/core";
import { APP_CONFIG, ApplicationSettings } from "@app/constants";
import { AppDataService } from "@app/services/appData.service";
import { forkJoin } from "rxjs";
import { AppRunService } from "@app/services/AppRunService";
import { IdleService } from "@app/services/idle.service";
import { AppDate } from "@app/util/app-date";

@Injectable()
export class AppInitService {

    constructor(@Inject(AppDataService) private appService: AppDataService,
                @Inject(AppRunService) private appRunService: AppRunService,
                @Inject(IdleService) private idleService: IdleService) {}

    initApp(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.idleService.init();
            this.loadData(resolve, reject)
        });
    }

    private loadData(resolve: (value: (PromiseLike<void> | void)) => void, reject: (reason?: any) => void) {
        this.appService.appConfig = APP_CONFIG();
        this.loadPushPopData();
        forkJoin([
            fetchSettings(),
            this.appRunService.run(),
        ]).subscribe(res => {
            this.appService.appSettings = res[0];
            //Setting the configured cutoff values
            this.configureCutoffValues();
            resolve();
        }, err => {
            reject(err)
        })

    }
    configureCutoffValues() {
        let scheduleCutoffTimeStr = this.appService.appSettings.scheduleCutoffTime.split(":");
        let oneTimeCutoffStr = this.appService.appSettings.oneTimeCutoff.split(":");
        this.appService.appConfig.CUTOFF_TIMEZONE = this.appService.appSettings.timezone;
        this.appService.appConfig.CUTOFF_HOUR_SCHEDULE = parseInt(scheduleCutoffTimeStr[0]);
        this.appService.appConfig.CUTOFF_MINUTE_SCHEDULE = parseInt(scheduleCutoffTimeStr[1]);
        this.appService.appConfig.CUTOFF_HOUR = parseInt(oneTimeCutoffStr[0]);
        this.appService.appConfig.CUTOFF_MINUTE= parseInt(oneTimeCutoffStr[1]);
        AppDate.timezone = this.appService.appSettings.timezone;

    }


    private loadPushPopData() {
        this.appService.pushPopItems = [{
            section: "properties",
            defaultRoute: "/properties",
            name: "Properties",
            iconClass: "Icon Icon--32 icon-utility-basics-home-32 u-strokeWhite",
            iconClassSelected: "Icon Icon--32 icon-utility-basics-home-32 u-strokeWhite",
            tid: "properties"
        },
        {
            section: "wallet",
            defaultRoute: "/wallet",
            name: "Wallet",
            iconClass: "Icon Icon--32 icon-objects-finance-wallet-32 u-strokeWhite HOA-tabbar__tab-icon--resize-95",
            iconClassSelected: "Icon Icon--32 icon-objects-finance-wallet-32 u-strokeWhite HOA-tabbar__tab-icon--resize-95",
            tid: "wallet"
        },
        {
            section: "contact",
            defaultRoute: "/contact",
            name: "Contact",
            iconClass: "Icon Icon--32 icon-utility-basics-phone-32 u-strokeWhite HOA-tabbar__tab-icon--resize-85",
            iconClassSelected: "Icon Icon--32 icon-utility-basics-phone-32 u-strokeWhite HOA-tabbar__tab-icon--resize-85",
            tid: "contact"
        },
        {
            section: "more",
            defaultRoute: "/more",
            name: "More",
            iconClass: "Icon Icon--32 icon-utility-basics-menu_hrz-32 u-iconWhite",
            iconClassSelected: "Icon Icon--32 icon-utility-basics-menu_hrz-32 u-iconWhite",
            isDropdownWhenWebFull: true,
            tid: "more"
        }];

    }
}

// We need to use the fetch method instead of the SettingApi
// This is because base class HOAApiBase sets up a circular dependency
// until the app is fully loaded
export function fetchSettings(): Promise<ApplicationSettings>  {
    let url = APP_CONFIG().get_APP_ENV().HOAPASS_API_URL + '/settings'

    url = url.replace(new URL(url).origin, '');

    return fetch(url, { "method":"GET" }).then(response => response.json());
}

export function init(appInit: AppInitService) { return () => appInit.initApp(); }

export const appInitProvider = { provide: APP_INITIALIZER, useFactory: init, deps: [AppInitService], multi: true }
